import * as model from "@/model/master/Material";
import { newEntityStoreHelper } from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}


export default newEntityStoreHelper(() => new model.Material(), newFilter)
    .withStates({
        idReport: 2,
        baseModuleUrl: process.env.VUE_APP_MASTER_API_URL + "master-service/master"
    }) 
    .buildStore()